import { useIsLaptop } from '@synoptic/ui-kit/responsive/hooks.js';
import { ReactNode, FC, useState, useMemo } from 'react';
import { getPersistedState, persistState } from '@/state-utils/persisted-state';
import { SidebarContextProvider } from './sidebar-context';

enum SidebarState {
  Expanded = 'expanded',
  Collapsed = 'collapsed',
}

const SIDEBAR_STATE_KEY = 'sidebar-state';

export const SidebarProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(
    () =>
      getPersistedState(
        SIDEBAR_STATE_KEY,
        SidebarState,
        SidebarState.Expanded,
      ) === SidebarState.Collapsed,
  );
  const isLaptop = useIsLaptop();

  const contextValue = useMemo(
    () => ({
      isCollapsed: isCollapsed && isLaptop,
      setIsCollapsed: (value: boolean | ((prev: boolean) => boolean)) => {
        const next = typeof value === 'function' ? value(isCollapsed) : value;
        setIsCollapsed(next);
        persistState(
          SIDEBAR_STATE_KEY,
          next ? SidebarState.Collapsed : SidebarState.Expanded,
        );
      },
    }),
    [isCollapsed, isLaptop],
  );

  return (
    <SidebarContextProvider value={contextValue}>
      {children}
    </SidebarContextProvider>
  );
};
